// Assets
import Logo from 'assets/images/logo.png'

export const ViewSection = ({
  errorCode = "",
  errorMessage = "",
  image
}) => {
  return (
    <section
      className='position-relative'
      style={{
        height: window.innerHeight,
        backgroundImage: `linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ), url(${image})`,
        backgroundRepeat: 'no-repeat',
        WebkitBackgroundSize: 'cover',
        MozBackgroundSize:  'cover',
        OBackgroundSize: 'cover',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div
        className="position-absolute top-50 start-0 translate-middle-y"
        style={{ width: '100%' }}
      >
        <div className='container' style={{ marginBottom: 150 }}>
          <img
            className='mb-5'
            src={Logo}
            alt="Logo"
            style={{
              maxWidth: 250
            }}
          />

          <section>
            <h2 className='text-white m-0' style={{ fontSize: 100 }}>ERROR</h2>
            <h1 className='text-white m-0 fw-bolder' style={{ fontSize: 150 }}>{errorCode}</h1>
            <div className='text-white mt-3' style={{ fontSize: 25 }}>{errorMessage}</div>
          </section>
        </div>
      </div>
    </section>
  )
}